import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
export const SearchRow = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const { searchImprovements } = useTemporaryFeatureFlags();
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("m-0 box-border flex w-full items-center justify-between p-0", searchImprovements ? "gap-2" : "max-w-screen-sm"),
        children: children
    });
});
SearchRow.displayName = "SearchRow";
